import type { TransactionFailedProperties } from '@/ampli';

import { ApiError } from '@/lib/errors/api';

import { isNetworkError } from '@/utils/submissionReason';

type FailureReason = TransactionFailedProperties['failure_reason'];

export const getFailureReason = (error: Error): FailureReason => {
  const message = error.message.toLowerCase();
  if (message.includes('user rejected')) return 'user_rejected';
  if (message.includes('transaction underpriced')) return 'rpc_error';
  return 'submission_error';
};

export const getGaslessFailureReason = (error: Error): FailureReason => {
  if (error instanceof ApiError) {
    if (error.statusCode >= 500) return 'relayer_unavailable';
    if (error.statusCode >= 400) return 'relayer_rejected';
  }
  if (isNetworkError(error)) return 'network_error';
  return 'submission_error';
};
